<template>
    <div v-if="count > 0" class="ml-4 px-3 py-1 rounded-full bg-yellow-500 text-white text-sm font-medium shadow">
        📦 {{ count }} pending
    </div>
</template>

<script setup>
import { useOutboxStore } from '@/stores/outbox'
import { storeToRefs } from 'pinia'

const outbox = useOutboxStore()
const { count } = storeToRefs(outbox)
</script>
